import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

import { apiPaths } from '../../../service/apiPaths';
import ApiService from '../../../service/ApiService';

const useDailyTask = () => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [date, setDate] = useState<string>("");
  const [selectedDate, setSelectedDate] = useState<string>("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [comments, setComments] = useState("");
  const [selectedTaskId, setSelectedTaskId] = useState("");
  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setSelectedDate(today);
    setDate(today);
    fetchData(today);
  }, []);
  const [localTaskHours, setLocalTaskHours] = useState<Record<string, number>>(
    {}
  );

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newDate = e.target.value;
    setSelectedDate(newDate);
    setDate(newDate);
    fetchData(newDate);
  };

  const handleAddComment = async () => {
    try {
      await ApiService({
        method: "PUT",
        endpoint: apiPaths.dailyTaskComments,
        data: {
          taskId: selectedTaskId,
          comments,
          date: selectedDate,
        },
      });
      setComments("");
      toast.success("comment updated...", {
        duration: 3000,
      });
      setIsModalOpen(false);
    } catch (error) {
      console.error("Error update in  comment:", error);
      toast.error("Error update comment:", {
        duration: 3000,
      });
    }
  };
  const fetchData = async (dateToFetch?: string) => {
    const dateValue = dateToFetch || date;
    if (!dateValue) return;

    setLoading(true);
    try {
      const response = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.getDailyTasks}${dateValue}`,
      });
      setData(response);
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    } finally {
      setLoading(false);
    }
  };

  const calculateTotalHoursAndMinutes = () => {
    let totalMinutes = 0;
  
    data.forEach((taskData) => {
      taskData.todayTaskIds.forEach((task : any) => {
        const localHours = localTaskHours[task._id];
        const taskHours = localHours ?? task.hours; 
        totalMinutes += Math.round(taskHours * 60); 
      });
    });
  
    const displayHours = Math.floor(totalMinutes / 60);
    const displayMinutes = totalMinutes % 60;
  
    return { displayHours, displayMinutes };
  };

  return {
    loading,
    data,
    fetchData,
    setDate,
    isModalOpen,
    setIsModalOpen,
    comments,
    setComments,
    selectedTaskId,
    setSelectedTaskId,
    selectedDate,
    handleDateChange,
    handleAddComment,
    setLocalTaskHours,
    localTaskHours,
    calculateTotalHoursAndMinutes,
  };
};

export default useDailyTask;
